import { Typography } from "@mui/material";
import "./style.scss";
import citiisvalues from "../../../../assets/svgs/citiisvalues.svg";
// import ourvaluesgraph2 from "../../../../assets/homepage/ourvaluesgraph2.png";
// import ourvaluesgraph3 from "../../../../assets/homepage/ourvaluesgraph3.png";
import ourvaluesgraph4 from "../../../../assets/homepage/ourvaluesgraph4.png";
import { AOSContainer } from "../../../../common/AOSContainer";
import { useNavigate } from "react-router-dom";
import CustomTooltip from "../../../../common/Tooltip";
import ReactHtmlParser from "react-html-parser";

const WhatIsCitiis = (props) => {
  const { whatiscitiisdata } = props;
  const navigate = useNavigate();
  console.log("whats is citiis section whatiscitiisdata", whatiscitiisdata);
  return (
    <div className=" whtcitiesmaindiv">
      <div className="row secondcompdiv">
        <div className="col-md-12 textcities1">
          <AOSContainer animationType="fade-right">
            <Typography variant="thinmedium" style={{ color: "#525151" }}>
              {/* What is */}
              {ReactHtmlParser(
                whatiscitiisdata && whatiscitiisdata[0]?.Heading
              )}
            </Typography>

            {/* <Typography variant="thicklarge" style={{ color: "#525151" }}>
              CITIIS?
            </Typography> */}

            <Typography variant="thinsmall" sx={{ marginTop: "20px" }}>
              {/* CITIIS, or the{" "}
              <Typography variant="thicksmall" component="span">
                City Investments to Innovate, Integrate and Sustain
              </Typography>
              , is a sub-component of the Government of India's Smart Cities
              Mission. */}
              {ReactHtmlParser(whatiscitiisdata && whatiscitiisdata[0]?.Text)}
            </Typography>
            {/* <Typography variant="thinsmall" sx={{ marginTop: "20px" }}>
              It is a joint program of the Ministry of Housing and Urban
              Affairs, Agence Francaise de Development (AFD), the European Union
              (EU), and the National Institute of Urban Affairs (NIUA)
            </Typography> */}
          </AOSContainer>
        </div>
        {/* <div className="col-md-6 ">
          <AOSContainer animationType="fade-left">
            <div className="whtiscitiesgraphicupper">
              <img
                src={whatiscitiisdata && whatiscitiisdata[0]?.Image}
                className="whtiscitiesgraphic"
              />
              <CustomTooltip title="Click to view CITIIS Values">
                <div
                  className="citiisvalbtn"
                  onClick={() => {
                    navigate("/whoweare");
                    localStorage.setItem("citiisval", "citiisval");
                  }}
                >
                  hello
                </div>
              </CustomTooltip>
            </div>
          </AOSContainer>
        </div> */}
      </div>
    </div>
  );
};

export default WhatIsCitiis;
